import { render, staticRenderFns } from "./TipoAtencion.vue?vue&type=template&id=f40e2f1e"
import script from "./TipoAtencion.vue?vue&type=script&lang=ts"
export * from "./TipoAtencion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports